export const DEV_BASE_URL = 'http://www.vmfhomeloan.com/consumer-affairs';
export const DEV_WEB_SERVICE_URL = 'https://dev.cmhinfo.biz/WebServices3'; 
export const LEAD_API_ENDPOINT = 'leads';


// WEBPACK FOOTER //
// ./src/utils/constants.js